import { useState, useEffect } from 'react';
import { createPopper } from '@popperjs/core';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const defaultPopperOptions = {};
function usePopper(parent, child, popperProps) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let popperInstance;
    setReady(false);
    if (child && parent) {
      popperInstance = createPopper(parent, child, __spreadValues(__spreadValues({}, defaultPopperOptions), popperProps));
      setReady(true);
    }
    return () => {
      if (popperInstance) {
        popperInstance.destroy();
      }
    };
  }, [child, parent, popperProps]);
  return ready;
}
function usePopperWithRefs(triggerRef, contentRef, arrow, hasArrow, popperProps) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let popperInstance;
    setReady(false);
    if (triggerRef.current && contentRef.current && (hasArrow && arrow || !hasArrow)) {
      popperInstance = createPopper(triggerRef.current, contentRef.current, __spreadValues(__spreadValues({}, defaultPopperOptions), popperProps));
      setReady(true);
    }
    return () => {
      if (popperInstance) {
        popperInstance.destroy();
        setReady(false);
      }
    };
  }, [triggerRef, contentRef, popperProps, arrow, hasArrow]);
  return ready;
}

export { usePopper, usePopperWithRefs };
//# sourceMappingURL=usePopper.es.js.map
